import styled from 'styled-components'

export const StaticContainer = styled.div`
	overflow-x: hidden;
	overflow-y: hidden;
`